import React, { useState } from 'react'
import { FaMobileScreen } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import './CancellationForm.scss'
import { MdConfirmationNumber } from "react-icons/md";
import { FaUser } from "react-icons/fa";
import { FaCalendarAlt } from "react-icons/fa";
import { FaClock } from "react-icons/fa";
import { GiShuttlecock } from "react-icons/gi";
import { RiTeamLine } from "react-icons/ri";
import logo from '../assets/kosmos-logo.png'
import axios from 'axios';
import { deleteRerveredslot } from '../Services/BackendUrl';
import { encryptedAuth } from '../Services/EncryptData';
import { FcOk } from "react-icons/fc";





const CancelationForm = () => {

  const [formData, setFormData] = useState({ 
    reservationIds: "",
});

const [toast, setToast] = useState(false);


const handleCancel = async (e) => {
  e.preventDefault();

  const { reservationIds } = formData;

  try {
    await axios.post(
      deleteRerveredslot,
      { reservationIds: [reservationIds] }, 
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Encrypted ${encryptedAuth}`,
        },
      }
    );
    setToast(true)
    setFormData({ reservationIds: "" }); 
  } catch (error) {
    console.error("Error cancelling reservation:", error);
    alert("Failed to cancel reservation. Please try again.");
  }
};

    const handleOnchange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
      };


  return (
    <div className=' items-center flex justify-center '>
        <img src={logo} alt="" width={50} height={50}  className='bg-black absolute top-5 left-5'/>

        <div className='w-[950px]' >
        <div>
            <div className='py-8 flex flex-col gap-4 items-center'>
            <h1 className='text-xl md-2xl'>Cancellation Form</h1>
            </div>
            <hr />
            <form className="form-section">
        <div className="input-section">
        <div className="label-input">
            <label>Reservation ID</label>
            <MdConfirmationNumber
              style={{ position: "absolute", top: "52px", left: "15px" }}
            />
            <input
              name="reservationIds"
              className="confirm-input"
              type='tel'
              value={formData.reservationIds}
              placeholder="Enter Reservation ID..."
              onChange={handleOnchange}
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </div>
          <div className="label-input">
            <label>Name</label>
            <FaUser
              style={{ position: "absolute", top: "52px", left: "15px" }}
            />
            <input
              // name="email"
              className="confirm-input"
              type="email"
            //   value={formData.email}
              placeholder="Enter Name..."
            //   onChange={handleOnchange}
            />
          </div>
          <div className="label-input">
            <label>Date</label>
            <FaCalendarAlt
              style={{ position: "absolute", top: "52px", left: "15px" }}
            />
            <input
              // name="email"
              className="confirm-input"
              type="email"
            //   value={formData.email}
              placeholder="Enter Booked Date..."
            //   onChange={handleOnchange}
            />
          </div>
          <div className="label-input">
            <label>Time</label>
            <FaClock
              style={{ position: "absolute", top: "52px", left: "15px" }}
            />
            <input
              // name="email"
              className="confirm-input"
              type="email"
            //   value={formData.email}
              placeholder="Enter Booked Time..."
            //   onChange={handleOnchange}
            />
          </div>
          <div className="label-input">
            <label>Court Number</label>
            <GiShuttlecock
              style={{ position: "absolute", top: "52px", left: "15px" }}
            />
            <input
              // name="email"
              className="confirm-input"
              type="email"
            //   value={formData.email}
              placeholder="Enter Booked Court No..."
            //   onChange={handleOnchange}
            />
          </div>

          <div className="label-input">
            <label> Player Count</label>
            <input
              // name="fullName"
              className="confirm-input"
              type="text"
              placeholder="Enter Player Count..."
            //   onChange={handleOnchange}
            />
            <RiTeamLine
              style={{ position: "absolute", top: "52px", left: "15px" }}
            />
          </div>
          <div className="label-input">
            <label> Mobile Number</label>
            <input
              // name="mobileNumber"
              className="confirm-input"
              type="tel"
            //   value={formData.mobileNumber}
              placeholder="Enter mobile number..."
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              maxLength={10}
            //   onChange={handleOnchange}
            />
            <FaMobileScreen
              style={{ position: "absolute", top: "52px", left: "15px" }}
            />
          </div>
          <div className="label-input">
            <label> Email ID</label>
            <MdEmail
              style={{ position: "absolute", top: "52px", left: "15px" }}
            />
            <input
              // name="email"
              className="confirm-input"
              type="email"
            //   value={formData.email}
              placeholder="Enter email..."
            //   onChange={handleOnchange}
            />
          </div>
          {
          toast && 
          <div className="toaster">
          <div className="toast-message">
            <FcOk />
            Reservation Canceled Successfully
          </div>
        </div>
        }

        </div>
        <button onClick={handleCancel} className="confirm-btn">
          CANCEL BOOKING
        </button>

      </form>
        </div>
    </div>
    </div>

  )
}

export default CancelationForm
